// extracted by mini-css-extract-plugin
export var columnList = "_fb-0";